<template>
  <article>
    <h1>We&rsquo;ll be back soon!</h1>
    <div>
      <p>
        Sorry for the inconvenience but we&rsquo;re performing some maintenance
        at the moment. If you need to you can always
        <a
          href="mailto:geral@xerpa-md.com
"
          >contact us</a
        >, otherwise we&rsquo;ll be back online shortly!
      </p>
      <p>&mdash; The Xerpa Team</p>
      <img src="maintenance.png" />
    </div>
  </article>
</template>

<script>
export default {}
</script>

<style>
img {
  width: 350px;
  height: 200px;
  object-fit: contain;
}

h1 {
  font-size: 30px;
}

article {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0;
  padding: 10px;
  padding-bottom: 0px;
  width: 100vw;
  height: 100%;
}
a {
  color: #dc8100;
  text-decoration: none;
}
a:hover {
  color: #333;
  text-decoration: none;
}
</style>
